export default __webpack_public_path__ + "static/media/still1.7413ab43.jpg";